<template>
    <div>
        <template v-if="error">
            <div class="error" v-if="error">
                <p>
                    {{$t('error')}}
                </p>
                <button
                        type="button"
                        @click="loadFirstResources"
                >
                    {{$t('retry')}}
                </button>
            </div>
        </template>

        <div
                v-show="!error"
                class="carousel-wrapper"
        >
            <div
                    class="arrow left"
                    :class="{disabled: isEndOfLeftScroll}"
                    @click="scrollLeft"
            >
                <div class="draw"></div>
            </div>
            <div
                    class="arrow right"
                    :class="{disabled: isEndOfRightScroll}"
                    @click="scrollRight"
            >
                <div class="draw"></div>
            </div>

            <div
                    class="carousel"
                    ref="carousel"
            >
                <template
                        v-if="loading"
                >
                    <slot name="loading">
                        <div
                                v-for="numb in perPage"
                                :key="numb"
                                class="slide"
                        >
                            <slot name="placeholder" :element="{}">

                            </slot>
                        </div>
                    </slot>
                </template>

                <template v-else>
                    <div
                            class="slide"
                            v-for="resourceElement in elements"
                            :key="resourceElement.id"
                            v-if="elements.length"
                    >
                        <slot :element="resourceElement">
                            {{JSON.stringify(resourceElement)}}
                        </slot>
                    </div>
                    <p v-if="elements.length === 0">
                        {{$t('noRecords')}}
                    </p>
                    <div
                            v-if="loadingMore"
                            class="slide"
                    >
                        <Spinner v-if="loadingMore"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from './Spinner';
    import EventBus from '../eventbus';
    import ResizeObserver from "resize-observer-polyfill";

    export default {
        components: {
            Spinner
        },
        props: {
            resource: {
                type: Object,
                required: true,
            },
            params: {
                type: Object,
                required: false,
                default: () => ({})
            },
            defaultParams: {
                type: Object,
                required: false,
                default: () => ({})
            },
            perPage: {
                required: false,
                default: 4
            },
            showIfEmpty: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        data(){
            return {
                elements: [],
                loading: true,
                loadingMore: false,
                error: false,
                lastLoadedPage: null,
                paginationParams: {
                    page: 1,
                    per_page: this.perPage,
                },
                paginationMeta: {
                    total: null,
                    total_pages: null,
                    count: null,
                },
                scrollData: {
                    left: 0,
                    right: 0,
                    rightLimit: 0,
                    leftLimit: 0,
                    width: 0,
                },
                slideMovementTimeout: null,
                isEmpty: false,
            };
        },
        methods: {
            loadFirstResources(){
                //this.$emit('elementsCount', 0);

                this.elements = [];
                this.loading = true;
                this.loadingMore = false;
                this.error = false;
                this.lastLoadedPage = null;
                this.paginationParams = {
                    page: 1,
                    per_page: this.perPage,
                };

                this.paginationMeta = {
                    total: null,
                    total_pages: null,
                    count: null,
                };

                this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
            },
            loadMoreResources(){
                this.loadingMore = true;

                this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
            },
            addResources(params){
                this.resource.index(params)
                    .then((response) => {
                        this.loading = false;
                        this.loadingMore = false;
                        this.elements = this.elements.concat(response.data.data);
                        this.paginationMeta = response.data.meta.pagination;
                        this.lastLoadedPage = params.page;

                    }).catch(() => {
                        this.loading = false;
                        this.error = true;
                    });
            },
            endOfScrollReached(){
                if(!this.loadingMore && this.paginationMeta.total_pages >= this.paginationParams.page){
                    this.loadMoreResources();
                }
            },
            scrollRight(){
                this.$refs.carousel.scrollLeft += 500;
            },
            scrollLeft(){
                this.$refs.carousel.scrollLeft -= 500;
            },
            updateScrollLimits(){
                let target = this.$refs.carousel;

                if(target !== undefined){
                    this.scrollData = {
                        ...this.scrollData,
                        leftLimit: 0,
                        rightLimit: target.scrollWidth,
                    };
                }
            },
            updateScroll(){
                let target = this.$refs.carousel;

                this.scrollData = {
                    ...this.scrollData,
                    left: target.scrollLeft,
                    right: target.offsetWidth + target.scrollLeft,
                };
            }
        },
        watch: {
            'paginationParams.defaultParams': function(value){
                this.loadFirstResources();
            },
            'paginationParams.params': function(value){
                this.loadFirstResources();
            },
            'perPage': function(value){
                this.paginationParams.per_page = value;
            },
            'lastLoadedPage': function(value){
                if(value === null){
                    this.paginationParams.page = 1;
                }else{
                    this.paginationParams.page = value + 1;
                }
            },
            isEndOfRightScroll(end, oldEnd){
                if(end === true && end !== oldEnd){
                    this.endOfScrollReached();
                }
            },
            elements: {
                handler(){
                    this.$emit('elementsCount', this.elements.length);
                },
                deep: true,
            }
        },
        mounted(){
            this.loadFirstResources();

            this.$refs.carousel.addEventListener('scroll', this.updateScroll);

            this.$refs.carousel.addEventListener('mousemove', (event) => { /* Mouse enter */
                let carousel = this.$refs.carousel;
                let slide = event.target.closest('.slide:hover');

                if(this.slideMovementTimeout){
                    clearTimeout(this.slideMovementTimeout);
                    this.slideMovementTimeout = null;
                }

                if(slide && DOMRectReadOnly !== undefined){
                    this.slideMovementTimeout = setTimeout(() => {
                        let carouselDomRect = carousel.getBoundingClientRect();
                        let slideDomRect = slide.getBoundingClientRect();

                        let domRect = new DOMRectReadOnly(
                            slideDomRect.x - carouselDomRect.x + carousel.scrollLeft,
                            slideDomRect.y - carouselDomRect.y + carousel.scrollTop,
                            slideDomRect.width,
                            slideDomRect.height,
                        );

                        if(domRect.right > (carousel.offsetWidth + carousel.scrollLeft)){
                            carousel.scrollLeft = domRect.right - carousel.offsetWidth;
                            this.updateScroll();
                        }else if(domRect.left < carousel.scrollLeft){
                            carousel.scrollLeft = domRect.left;
                            this.updateScroll();
                        }
                    }, 500);
                }
            });

            this.updateScrollLimits();
            this.updateScroll();

            /* Si cambia el tamaño del carousel actualiza el scroll */
            new ResizeObserver((element) => {
                this.updateScrollLimits();
            }).observe(this.$refs.carousel);

            /* Si aparecen / desaparecen items actualiza el scroll */
            new MutationObserver((mutations) => {
                this.updateScrollLimits();
            }).observe(this.$refs.carousel, {childList: true,});

            EventBus.$on('languageChanged', () => {
                this.loadFirstResources();
            });
        },
        computed: {
            isEndOfRightScroll(){
                return this.scrollData.right >= this.scrollData.rightLimit;
            },
            isEndOfLeftScroll(){
                return this.scrollData.left <= 0;
            }
        },
        beforeDestroy(){
            clearTimeout(this.slideMovementTimeout);
            this.slideMovementTimeout = null;
        }

    }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

    .carousel-wrapper{
        position: relative;

        @media(min-width: 770px) and (max-width: 1440px){

        }

        &:focus{
            .arrow{
                .draw{
                    opacity: 1;
                }
            }
        }

        .arrow{
            position: absolute;
            height: 100%;
            display: flex;

            @media(max-width: 770px){
                display: none;
            }

            .draw{
                transition: opacity .5s ease;
                opacity: 1;
                cursor: pointer;
                align-self: center;
                height: 0;
                width: 0;
                border: 50px solid transparent;
                user-select: none;
                z-index: 10;
            }

            &.disabled{
                &.left{
                    .draw{
                        //border-right: 25px solid rgba(125, 125, 125, 1) !important;
                        opacity: .35;
                    }
                }

                &.right{
                    .draw{
                        //border-left: 25px solid rgba(125, 125, 125, 1) !important;
                        opacity: .35;
                    }
                }
            }

            &.left{
                left: -50px;
                width: 0;

                @media(max-width: 1440px){
                    left: 0px;

                    .draw{
                        border-right-color: var(--pallete_main_color) !important;
                    }
                }

                .draw {
                    border-left: 0;
                    border-right: 25px solid rgba(125,125,125,1);
                }
            }

            &.right{
                right: -25px;
                width: 0;

                @media(max-width: 1440px){
                    right: 25px;

                    .draw{
                        border-left-color: var(--pallete_main_color) !important;
                    }
                }

                .draw{
                    border-right: 0;
                    border-left: 25px solid rgba(125,125,125,1);
                }
            }
        }

        .carousel{
            scroll-behavior: smooth;

            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            overflow-scrolling: touch;
            justify-content: flex-start;

            -ms-overflow-style: none;  /* IE 10+ */
            overflow: -moz-scrollbars-none; /* should hide scroll bar */

            &::-webkit-scrollbar{
                display: none; /*  might be enough */
                background: transparent;
                visibility: hidden;
                width: 0;
            }

            .slide{
                width: auto;
                flex: 0;

                &:hover{
                    //background-color: #ff0000;
                }
            }
        }
    }

    .error{
        text-align: center;
    }

    .loading{
        text-align: center;
    }
</style>